export const messages = {
  validation: {
    requiredField: "Required field",
    invalidLogin: "Incorrect username and / or password."
  },
  exception: {}
};
